/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Badge, Group, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { MRT_ColumnDef } from 'mantine-react-table';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { CustomTable } from '../../../../../components/core/CustomTable/CustomTable';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import { ContractSearchResponseType } from '../../../../../models/core/contracts.type';
import theme from '../../../../../theme';
import { formatDateToString } from '../../../../../utils/formatter.utils';
import DataViewActions from './DataViewActions';

type DataViewProps = {
  data: ContractSearchResponseType[];
  confirmActionResult(
    item: ContractSearchResponseType,
    action: string,
    confirmed: boolean,
    payload?: { dataFinal?: string }
  ): void;
};
export default function DataView(props: DataViewProps) {
  const columns = useMemo<MRT_ColumnDef<ContractSearchResponseType>[]>(
    () => [
      {
        header: '#',
        id: 'idContrato',
        accessorKey: 'idContrato',
        sortingFn: (a, b) => a.original.idContrato - b.original.idContrato,
        Cell: ({ row }) => (
          <Link to={`./${row.original.idContrato}`} target="_blank">
            {row.original.idContrato}
          </Link>
        ),
        size: 60,
      },
      {
        header: 'Proposta',
        id: 'idProposta',
        accessorKey: 'idProposta',
        sortingFn: (a, b) => a.original.idProposta - b.original.idProposta,
        Cell: ({ row }) => (
          <ProfileCardLink
            id={row.original.idProposta.toString()}
            name="Proposta"
            nameSize="sm"
            description={`# ${row.original.idProposta}`}
            descriptionSize="xs"
            linkPrefix="proposals"
            showLink
          />
        ),
      },
      {
        header: 'Empresa',
        id: 'empresa',
        accessorFn: (row) => row.empresa,
        Cell: ({ cell }) => <Badge variant="outline">{cell.getValue<string>()}</Badge>,
      },
      {
        header: 'Cliente',
        id: 'cliente',
        accessorFn: (row) =>
          `${row.clienteNomeFantasia ?? ''}|${row.clienteRazaoSocial ?? ''}|${row.clienteNome ?? ''}|${
            row.clienteCNPJ ?? ''
          }|${row.clienteCPF ?? ''}`,
        sortingFn: (a, b) =>
          (
            a.original.clienteNomeFantasia ||
            a.original.clienteRazaoSocial ||
            a.original.clienteNome ||
            ''
          ).localeCompare(
            b.original.clienteNomeFantasia || b.original.clienteRazaoSocial || b.original.clienteNome || ''
          ),
        Cell: ({ row }) => {
          const data = row.original;
          return data.clienteCNPJ ? (
            <ProfileCardLink
              id={data.idCliente.toString()}
              name={data.clienteNomeFantasia || data.clienteRazaoSocial || '-'}
              nameSize="sm"
              description={data.clienteNomeFantasia ? data.clienteRazaoSocial : data.clienteCNPJ}
              descriptionSize="xs"
              linkPrefix="entities"
              showLink
            />
          ) : (
            <ProfileCardLink
              id={data.idCliente.toString()}
              name={data.clienteNome || '-'}
              nameSize="sm"
              description={data.clienteCPF}
              descriptionSize="xs"
              linkPrefix="entities"
              showLink
            />
          );
        },
      },
      {
        header: 'Status',
        accessorKey: 'contratoStatus',
        sortingFn: (a, b) => a.original.contratoStatus.localeCompare(b.original.contratoStatus),
        Cell: ({ cell }) => <Badge variant="outline">{cell.getValue<string>()}</Badge>,
      },
      {
        header: 'Data Inicial',
        id: 'dataInicial',
        accessorFn: (row) => new Date(row.dataInicial),
        filterVariant: 'date-range',
        sortingFn: 'datetime',
        enableColumnFilterModes: false,
        Cell: ({ row }) => formatDateToString(row.original.dataInicial),
      },
      {
        header: 'Data Final',
        id: 'dataFinal',
        accessorFn: (row) => new Date(row.dataFinal),
        filterVariant: 'date-range',
        sortingFn: 'datetime',
        enableColumnFilterModes: false,
        Cell: ({ row }) => (
          <Group>
            <div>{formatDateToString(row.original.dataFinal)}</div>
            {row.original.dataFinalOriginal && (
              <Tooltip
                withArrow
                transitionProps={{ transition: 'fade', duration: 200 }}
                label={`Data Original: ${formatDateToString(row.original.dataFinalOriginal || new Date())}`}
              >
                <div>
                  <IconInfoCircle
                    style={{ marginLeft: -10, verticalAlign: 'top' }}
                    size={18}
                    color={theme?.colors?.accent?.[6]}
                  />
                </div>
              </Tooltip>
            )}
          </Group>
        ),
      },
    ],
    []
  );

  return (
    <CustomTable
      columns={columns}
      data={props.data}
      initialState={{
        columnVisibility: { empresa: false },
      }}
      globalFilterFn="contains"
      enableRowActions
      positionActionsColumn="last"
      displayColumnDefOptions={{ 'mrt-row-actions': { size: 130 } }}
      renderRowActions={(renderProps) => (
        <DataViewActions item={renderProps.row.original} confirmActionResult={props.confirmActionResult} />
      )}
    />
  );
}
